import React from 'react'
export default function Spinner() {
  return (
    <div className="text-center">
        <div className="spinner-border" role="status">
        </div>
      </div>
  )
}